'use client';
import { Button, Input } from '@leva/ui';
import React, { useState } from 'react';

export function ForgotPasswordForm() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setPending(true);
    try {
      await fetch('/api/auth/password-reset/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      }).catch(() => undefined);
    } finally {
      setSent(true);
      setPending(false);
    }
  }

  if (sent) {
    return (
      <div role="status" aria-live="polite" className="rounded-xl bg-sand p-4 text-sm text-brown">
        Jika email tersebut terdaftar di Leva, kami telah mengirim link reset password. Periksa
        kotak masuk Anda (dan folder spam) dalam beberapa menit ke depan.
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-semibold text-brown mb-1.5" htmlFor="email">
          Email
        </label>
        <Input
          id="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <Button type="submit" size="lg" className="w-full" disabled={pending}>
        {pending ? 'Mengirim…' : 'Kirim link reset'}
      </Button>
    </form>
  );
}
